// extracted by mini-css-extract-plugin
module.exports = {"carousel":"carousel_carousel__3v2Od","content":"carousel_content__3r7Xb","control":"carousel_control__2JmfD"};